import './ReportLayout.css';

export const ReportLayout = ({ children }) => {
  return (
    <div className="seo-checker-layout">
      <div className="seo-checker-layout__container">
        {children}
      </div>
    </div>
  );
};

